// extracted by mini-css-extract-plugin
export var divider = "_tn-0";
export var systemMessage = "_tn-1";